import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';

const NARROW_QUERY = '(max-width: 750px)';

@Component({
  name: 'ResizeMixin',
})
export default class extends Vue {
  private mediaQuery: MediaQueryList | null = null;

  public mounted() {
    this.mediaQuery = window.matchMedia(NARROW_QUERY);
    AppModule.SET_NARROW(this.mediaQuery.matches);
    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener('change', this.onMediaChange);
    } else {
      this.mediaQuery.addListener(this.onMediaChange);
    }
  }

  public beforeDestroy() {
    if (!this.mediaQuery) {
      return;
    }
    if (this.mediaQuery.removeEventListener) {
      this.mediaQuery.removeEventListener('change', this.onMediaChange);
    } else {
      this.mediaQuery.removeListener(this.onMediaChange);
    }
  }

  private onMediaChange = (event: MediaQueryListEvent) => {
    AppModule.SET_NARROW(event.matches);
  };
}
